import React, { useState, useMemo, useCallback } from 'react';
import qs from 'qs';

import moment from 'moment';
import { useParams } from 'react-router-dom';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons/faPrint';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons/faTimesCircle';

const ReportRibbon = ({
  api, refCode, calTaxFn, values,
}) => {
  const [title, setTitle] = useState('');
  const [signature, setSignature] = useState(false);
  const [french, setFrench] = useState(false);

  const { _id: id } = useParams();
  const { origin } = window.location;

  const report = useCallback(
    () => {
      const query = {
        _id: id,
        utcOffset: moment().utcOffset(),
        lg: french ? 'fr' : 'en',
        ...(title ? { title } : {}),
        ...(signature ? { signature } : {}),
      };
      const url = `${origin}${api}/report/${refCode || 'TaiPing'}?${qs.stringify(query)}`;
      window.open(url, '_blank');
    },
    [id, api, title, signature, french],
  );

  return useMemo(
    () => (
      <div className="row mb-3">
        <div className="col-5">
          <div className="input-group">
            <input
              className="form-control"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Report Title"
            />
            <div className="input-group-append">
              <button
                className={'btn btn-outline-primary'}
                onClick={() => setSignature((prev) => !prev)}
                type="button">
                <FA icon={signature ? faCheckCircle : faTimesCircle } className="mr-1" />
                Signature
              </button>
              <button
                className={'btn btn-outline-primary'}
                onClick={() => setFrench((prev) => !prev)}
                type="button">
                <FA icon={french ? faCheckCircle : faTimesCircle} className="mr-1" />
                French
              </button>
            </div>
            <button className="btn btn-outline-primary ml-4" onClick={() => report()} type="button">
              <FA icon={faPrint} className="mr-1" />
              Report
            </button>
          </div>
        </div>
        {calTaxFn && (
          <div className="col d-flex">
            <h6 className="text-muted small my-auto">
              Order will Sync to ERP, when order status changes to &quot;Booked&quot;
            </h6>
          </div>
        )}
      </div>
    ),
    [api, refCode, signature, french, title, JSON.stringify(values)],
  );
};

export default ReportRibbon;
